var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupplierDeclarations(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_sdm_001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 15.2V17.6C0.5 17.82 0.62 18.03 0.81 18.14L8.6 22.78C9.42 23.27 10.44 23.27 11.26 22.78L21.6 16.6C21.92 16.41 22.12 16.06 22.12 15.68V13.4L12.8 18.2L9.7 20.1L2.2 16.0L0.5 15.2Z",
    fill: "#F26F21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.7 23.18C9.22 23.18 8.74 23.05 8.31 22.79L0.52 18.15C0.3 18.02 0.16 17.78 0.16 17.52V15.2C0.16 15.16 0.18 15.13 0.21 15.11C0.24 15.09 0.28 15.09 0.31 15.11L2.2 16.0L9.65 20.04L12.7 18.16L22.0 13.32C22.03 13.3 22.07 13.3 22.1 13.32C22.13 13.34 22.15 13.38 22.15 13.42V15.7C22.15 16.1 21.93 16.49 21.57 16.7L11.23 22.88C10.8 23.13 10.31 23.26 9.82 23.26L9.7 23.18ZM0.37 15.37V17.52C0.37 17.7 0.47 17.87 0.63 17.96L8.42 22.6C9.21 23.07 10.2 23.07 10.99 22.6L21.33 16.42C21.62 16.25 21.8 15.93 21.8 15.59V13.26L12.72 17.97L9.61 19.84C9.58 19.86 9.54 19.86 9.51 19.84L2.06 15.8L0.37 15.37Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 20.22L0.87 15.18C0.41 14.92 0.41 14.25 0.87 13.99L12.44 7.08C12.65 6.96 12.91 6.96 13.12 7.08L21.87 12.18C22.33 12.44 22.33 13.12 21.87 13.38L10.3 20.22C10.09 20.34 9.83 20.34 9.62 20.22H9.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.96 20.42C9.83 20.42 9.7 20.39 9.58 20.32L0.95 15.28C0.71 15.14 0.56 14.88 0.56 14.6C0.56 14.32 0.71 14.06 0.95 13.92L12.52 7.01C12.76 6.87 13.06 6.87 13.3 7.01L22.05 12.05C22.29 12.19 22.44 12.45 22.44 12.73C22.44 13.01 22.29 13.27 22.05 13.41L10.48 20.32C10.36 20.39 10.22 20.42 10.09 20.42H9.96ZM12.78 7.12C12.69 7.12 12.6 7.14 12.52 7.19L0.95 14.1C0.77 14.2 0.66 14.39 0.66 14.6C0.66 14.81 0.77 15.0 0.95 15.1L9.58 20.14C9.74 20.23 9.93 20.23 10.09 20.14L21.66 13.23C21.84 13.13 21.95 12.94 21.95 12.73C21.95 12.52 21.84 12.33 21.66 12.23L12.91 7.19C12.83 7.14 12.74 7.12 12.65 7.12H12.78Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.2 3.8L4.4 5.4V12.5L7.2 10.9V3.8Z",
    fill: "#F26F21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.2 3.8L10.5 5.4V12.5L7.2 10.9V3.8Z",
    fill: "#FCB813"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.4 5.4L7.2 3.8L10.5 5.4L7.7 7.0L4.4 5.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.2 11.0C7.16 11.0 7.13 10.99 7.1 10.97L4.3 9.37C4.25 9.34 4.22 9.29 4.22 9.24V5.4C4.22 5.36 4.24 5.32 4.28 5.3L7.06 3.7C7.12 3.66 7.18 3.66 7.24 3.7L10.56 5.3C10.6 5.32 10.62 5.36 10.62 5.4V9.24C10.62 9.29 10.59 9.33 10.55 9.36L7.34 11.0C7.3 11.0 7.26 11.0 7.22 11.0H7.2ZM4.55 9.17L7.2 10.7L10.32 8.97V5.51L7.2 3.97L4.55 5.47V9.17Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.4 7.1L6.8 7.9",
    stroke: "#231F20",
    strokeWidth: 0.25,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.4 8.0L6.8 8.8",
    stroke: "#231F20",
    strokeWidth: 0.25,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4 6.2L9.5 6.9",
    stroke: "#231F20",
    strokeWidth: 0.25,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.4 7.1L9.5 7.8",
    stroke: "#231F20",
    strokeWidth: 0.25,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8 2.2L20.3 3.7V7.5L17.8 6.0V2.2Z",
    fill: "#F26F21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8 2.2L20.3 3.7L22.5 3.0L20.0 1.5L17.8 2.2Z",
    fill: "#FCB813"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3 3.7L22.5 3.0V6.8L20.3 7.5V3.7Z",
    fill: "#F26F21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1 7.65C20.07 7.65 20.04 7.64 20.01 7.62L17.56 6.07C17.51 6.04 17.48 5.99 17.48 5.94V2.14C17.48 2.1 17.5 2.06 17.54 2.04L19.76 1.37C19.82 1.35 19.88 1.36 19.93 1.39L22.38 2.94C22.43 2.97 22.45 3.02 22.45 3.07V6.87C22.45 6.91 22.43 6.95 22.39 6.97L20.17 7.64C20.15 7.64 20.13 7.65 20.11 7.65H20.1ZM17.82 5.85L20.09 7.27L22.11 6.67V3.16L19.84 1.74L17.82 2.34V5.85Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.7 4.3L19.5 5.1L21.1 3.3",
    stroke: "white",
    strokeWidth: 0.35,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5 6.5L17.5 4.0",
    stroke: "#231F20",
    strokeWidth: 0.2,
    strokeDasharray: "0.5 0.4",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.58 12.26C9.38 12.26 10.03 11.89 10.03 11.43C10.03 10.97 9.38 10.6 8.58 10.6C7.78 10.6 7.13 10.97 7.13 11.43C7.13 11.89 7.78 12.26 8.58 12.26Z",
    fill: "#F26F21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.58 12.36C7.71 12.36 7.03 11.95 7.03 11.43C7.03 10.91 7.71 10.5 8.58 10.5C9.45 10.5 10.13 10.91 10.13 11.43C10.13 11.95 9.45 12.36 8.58 12.36ZM8.58 10.71C7.85 10.71 7.24 11.04 7.24 11.43C7.24 11.82 7.85 12.15 8.58 12.15C9.31 12.15 9.92 11.82 9.92 11.43C9.92 11.04 9.31 10.71 8.58 10.71Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.8 13.8C6.6 13.8 7.25 13.43 7.25 12.97C7.25 12.51 6.6 12.14 5.8 12.14C5.0 12.14 4.35 12.51 4.35 12.97C4.35 13.43 5.0 13.8 5.8 13.8Z",
    fill: "#F26F21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.8 13.9C4.93 13.9 4.25 13.49 4.25 12.97C4.25 12.45 4.93 12.04 5.8 12.04C6.67 12.04 7.35 12.45 7.35 12.97C7.35 13.49 6.67 13.9 5.8 13.9ZM5.8 12.24C5.07 12.24 4.46 12.57 4.46 12.97C4.46 13.37 5.07 13.7 5.8 13.7C6.53 13.7 7.14 13.37 7.14 12.97C7.14 12.57 6.53 12.24 5.8 12.24Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.1 15.5C3.9 15.5 4.55 15.13 4.55 14.67C4.55 14.21 3.9 13.84 3.1 13.84C2.3 13.84 1.65 14.21 1.65 14.67C1.65 15.13 2.3 15.5 3.1 15.5Z",
    fill: "#F26F21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.1 15.6C2.23 15.6 1.55 15.19 1.55 14.67C1.55 14.15 2.23 13.74 3.1 13.74C3.97 13.74 4.65 14.15 4.65 14.67C4.65 15.19 3.97 15.6 3.1 15.6ZM3.1 13.94C2.37 13.94 1.76 14.27 1.76 14.67C1.76 15.07 2.37 15.4 3.1 15.4C3.83 15.4 4.44 15.07 4.44 14.67C4.44 14.27 3.83 13.94 3.1 13.94Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 14.08C12.3 14.08 12.95 13.71 12.95 13.25C12.95 12.79 12.3 12.42 11.5 12.42C10.7 12.42 10.05 12.79 10.05 13.25C10.05 13.71 10.7 14.08 11.5 14.08Z",
    fill: "#F26F21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5 14.18C10.63 14.18 9.95 13.77 9.95 13.25C9.95 12.73 10.63 12.32 11.5 12.32C12.37 12.32 13.05 12.73 13.05 13.25C13.05 13.77 12.37 14.18 11.5 14.18ZM11.5 12.52C10.77 12.52 10.16 12.85 10.16 13.25C10.16 13.65 10.77 13.98 11.5 13.98C12.23 13.98 12.84 13.65 12.84 13.25C12.84 12.85 12.23 12.52 11.5 12.52Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.55 15.86C15.35 15.86 16.0 15.49 16.0 15.03C16.0 14.57 15.35 14.2 14.55 14.2C13.75 14.2 13.1 14.57 13.1 15.03C13.1 15.49 13.75 15.86 14.55 15.86Z",
    fill: "#F26F21"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.55 15.96C13.68 15.96 13.0 15.55 13.0 15.03C13.0 14.51 13.68 14.1 14.55 14.1C15.42 14.1 16.1 14.51 16.1 15.03C16.1 15.55 15.42 15.96 14.55 15.96ZM14.55 14.3C13.82 14.3 13.21 14.63 13.21 15.03C13.21 15.43 13.82 15.76 14.55 15.76C15.28 15.76 15.89 15.43 15.89 15.03C15.89 14.63 15.28 14.3 14.55 14.3Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8 20.66C21.38 20.66 22.67 19.93 22.67 19.03C22.67 18.13 21.38 17.4 19.8 17.4C18.22 17.4 16.93 18.13 16.93 19.03C16.93 19.93 18.22 20.66 19.8 20.66Z",
    fill: "#FCB813"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8 20.77C18.15 20.77 16.82 20.0 16.82 19.03C16.82 18.06 18.15 17.29 19.8 17.29C21.45 17.29 22.78 18.06 22.78 19.03C22.78 20.0 21.45 20.77 19.8 20.77ZM19.8 17.5C18.27 17.5 17.03 18.19 17.03 19.03C17.03 19.87 18.27 20.56 19.8 20.56C21.33 20.56 22.57 19.87 22.57 19.03C22.57 18.19 21.33 17.5 19.8 17.5Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.82 19.03V21.1C16.82 22.07 18.15 22.84 19.8 22.84C21.45 22.84 22.78 22.07 22.78 21.1V19.03C22.78 20.0 21.45 20.77 19.8 20.77C18.15 20.77 16.82 20.0 16.82 19.03Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8 22.94C18.09 22.94 16.72 22.1 16.72 21.1V19.03C16.72 18.99 16.74 18.96 16.77 18.94C16.8 18.92 16.84 18.92 16.87 18.94C17.27 19.53 18.44 19.97 19.8 19.97C21.16 19.97 22.33 19.53 22.73 18.94C22.76 18.92 22.8 18.92 22.83 18.94C22.86 18.96 22.88 18.99 22.88 19.03V21.1C22.88 22.1 21.51 22.94 19.8 22.94ZM16.93 19.46V21.1C16.93 21.94 18.22 22.63 19.8 22.63C21.38 22.63 22.67 21.94 22.67 21.1V19.46C22.13 19.93 21.02 20.24 19.8 20.24C18.58 20.24 17.47 19.93 16.93 19.46Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9 19.1L19.6 19.8L21.0 18.3",
    stroke: "#231F20",
    strokeWidth: 0.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_sdm_001"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupplierDeclarations);
export default __webpack_public_path__ + "static/media/Supplier_Declarations.bea527e49dbd16d0c8c34922f048cc73.svg";
export { ForwardRef as ReactComponent };